import axios from "axios";
import Swal from "sweetalert2";
import LoginInterface from "../types/auth.interface";

// export async function login({
//   username,
//   password,
// }: LoginInterface): Promise<any> {
//   return await axios.post("login", { username, password });
// }

// accessToken;
const user = JSON.parse(localStorage.getItem("user") ?? "false");

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + `${user.accessToken}`,
};

class AuthService {
  login({ username, password }: LoginInterface) {
    // console.log(username);

    return axios
      .post("login", { username, password })
      .then((response) => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        axios.defaults.headers.common[
          "Authorization"
        ] = `${response.data.accessToken}`;

        return response.data;
      })
      .catch((error) => {
        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "ตรวจสอบ Username หรือ Password อีกครั้ง!",
        });
      });
  }

  async logout() {
    localStorage.removeItem("user");
    return await axios.post("logout");
  }

  register() {
    return { test: "register Page" };
  }
}

export default new AuthService();
